import { HUB_BRAND_STORAGE_KEY } from '@/store/slices/hubBrandPersistence';

type SafeStorage = {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
  clear: () => void;
};

type LocationLike = {
  origin: string;
  search: string;
  href: string;
};

type HistoryLike = {
  replaceState: (data: unknown, unused: string, url?: string | null) => void;
};

type ClearCacheDeps = {
  localStorage: SafeStorage;
  sessionStorage: Pick<SafeStorage, 'clear'>;
  location: LocationLike;
  history: HistoryLike;
  redirect: (href: string) => void;
};

// gloss
export const handleClearCache = ({
  localStorage,
  sessionStorage,
  location,
  history,
  redirect,
}: ClearCacheDeps): void => {
  const url = new URL(location.href);
  const clearCache = url.searchParams.get('clearCache');
  if (!clearCache || clearCache.toLowerCase() !== 'true') return;

  const existingInviteTag = localStorage.getItem('inviteTag');
  const existingHub = localStorage.getItem(HUB_BRAND_STORAGE_KEY);

  localStorage.clear();
  sessionStorage.clear();

  if (existingInviteTag) localStorage.setItem('inviteTag', existingInviteTag);
  if (existingHub) localStorage.setItem(HUB_BRAND_STORAGE_KEY, existingHub);

  url.searchParams.delete('clearCache');
  history.replaceState({}, '', url.toString());

  const isEmbedMode = new URLSearchParams(location.search).get('embed') === 'true';
  if (!isEmbedMode) redirect(location.origin);
};
